import { render, staticRenderFns } from "./ProductIndexing.vue?vue&type=template&id=13ca2914&scoped=true&"
import script from "./ProductIndexing.vue?vue&type=script&lang=js&"
export * from "./ProductIndexing.vue?vue&type=script&lang=js&"
import style0 from "./ProductIndexing.vue?vue&type=style&index=0&id=13ca2914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca2914",
  null
  
)

/* custom blocks */
import block0 from "./ProductIndexing.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VList,VTooltip})
